import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import axios from "axios";

// material-ui icons
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import AssessmentCard from "./AssessmentCard.js";

import styles from "assets/jss/elite-feats-cms/views/extendedTablesStyle.js";

import AppContext from "../../AppContext";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

export default function ExtendedTables(props) {
  const { t } = useTranslation();
  let assignment = JSON.parse(localStorage.getItem("assignment"));
  let order = JSON.parse(localStorage.getItem("order"));
  const {
    totalPurchased,
    totalUsed,
    pending,
    completed,
    subscriptionData,
    isMobile,
  } = props;
  const cartContext = React.useContext(AppContext);
  let initialChecked = [];
  for (let number in assignment) {
    if (assignment[number] === true) {
      initialChecked.push(number);
    }
  }

  const [checked, setChecked] = useState(initialChecked);
  const [subscriptionAvailable, setSubscriptionAvailable] = useState(0);
  const [loading, setLoading] = useState(true);
  const [effectiveAvailableUnits, setEffectiveAvailableUnits] = useState({
    tool1_1: totalPurchased.tool1_1 - totalUsed.tool1_1,
    tool1_2: totalPurchased.tool1_2 - totalUsed.tool1_2,
    tool1_3: totalPurchased.tool1_3 - totalUsed.tool1_3,
  });

  // Fetch subscription data
  useEffect(() => {
    try {
      const availableUnits =
        subscriptionData && subscriptionData.active
          ? subscriptionData.totalAvailable
          : 0;

      setSubscriptionAvailable(availableUnits);

      // Update the effective available units
      setEffectiveAvailableUnits({
        tool1_1:
          totalPurchased.tool1_1 -
          totalUsed.tool1_1 +
          (availableUnits > 0 ? 1 : 0),
        tool1_2:
          totalPurchased.tool1_2 -
          totalUsed.tool1_2 +
          (availableUnits > 0 ? 1 : 0),
        tool1_3:
          totalPurchased.tool1_3 -
          totalUsed.tool1_3 +
          (availableUnits > 0 ? 1 : 0),
      });
    } catch (error) {
      console.error("Error fetching subscription data:", error);
      // Fallback to just purchased - used
      setEffectiveAvailableUnits({
        tool1_1: totalPurchased.tool1_1 - totalUsed.tool1_1,
        tool1_2: totalPurchased.tool1_2 - totalUsed.tool1_2,
        tool1_3: totalPurchased.tool1_3 - totalUsed.tool1_3,
      });
    } finally {
      setLoading(false);
    }
  }, [totalPurchased, totalUsed]);

  useEffect(() => {
    if (!order.length && checked.length) {
      setChecked([]);
    }
  });

  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value.toString());
    const orderIndex = order.indexOf(value.toString());
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value.toString());
      order.push(value.toString());
      assignment[`${value}`] = true;
    } else {
      newChecked.splice(currentIndex, 1);
      order.splice(orderIndex, 1);
      assignment[`${value}`] = false;
    }
    setChecked(newChecked);
    localStorage.setItem("assignment", JSON.stringify(assignment));
    localStorage.setItem("order", JSON.stringify(order));
    props.triggerReload();
  };

  const classes = useStyles();

  // Tools data for both card and table views
  const tools = [
    {
      number: "1.1",
      name: t("assignments:assessmentNames.tool1_1"),
      purchased: totalPurchased.tool1_1,
      used: totalUsed.tool1_1,
      available: totalPurchased.tool1_1 - totalUsed.tool1_1,
      pending: pending.tool1_1,
      completed: completed.tool1_1,
      effectiveAvailable: effectiveAvailableUnits.tool1_1,
      key: "tool1_1",
    },
    {
      number: "1.2",
      name: t("assignments:assessmentNames.tool1_2"),
      purchased: totalPurchased.tool1_2,
      used: totalUsed.tool1_2,
      available: totalPurchased.tool1_2 - totalUsed.tool1_2,
      pending: pending.tool1_2,
      completed: completed.tool1_2,
      effectiveAvailable: effectiveAvailableUnits.tool1_2,
      key: "tool1_2",
    },
    {
      number: "1.3",
      name: t("assignments:assessmentNames.tool1_3"),
      purchased: totalPurchased.tool1_3,
      used: totalUsed.tool1_3,
      available: totalPurchased.tool1_3 - totalUsed.tool1_3,
      pending: pending.tool1_3,
      completed: completed.tool1_3,
      effectiveAvailable: effectiveAvailableUnits.tool1_3,
      key: "tool1_3",
    },
  ];

  // If mobile, render card view
  if (isMobile) {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card plain style={{ marginTop: -10, marginBottom: 0 }}>
            <CardBody>
              {tools.map((tool) => (
                <AssessmentCard
                  key={tool.number}
                  name={tool.name}
                  purchased={tool.purchased}
                  used={tool.used}
                  available={`${tool.available}${
                    subscriptionAvailable > 0
                      ? " + " + subscriptionAvailable
                      : ""
                  }`}
                  pending={tool.pending}
                  completed={tool.completed}
                  action={
                    tool.effectiveAvailable > 0 ? (
                      <Checkbox
                        key="key"
                        tabIndex={-1}
                        style={{ padding: 7 }}
                        onClick={() => handleToggle(tool.number)}
                        checked={assignment[tool.number]}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checkedDarkBlue,
                          root: classes.checkRoot,
                        }}
                      />
                    ) : (
                      <Button
                        color="tool1"
                        onClick={() => {
                          let currentCart = JSON.parse(
                            localStorage.getItem("cart")
                          );
                          currentCart[tool.key] += 1;
                          localStorage.setItem(
                            "cart",
                            JSON.stringify(currentCart)
                          );
                          cartContext.setCart(currentCart);
                        }}
                        round
                        size="sm"
                        style={{ padding: 4, paddingLeft: 15, paddingRight: 15 }}
                      >
                        {t("assignments:addToCart")}
                      </Button>
                    )
                  }
                />
              ))}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }

  // Desktop: render table view
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card plain style={{ marginTop: -10, marginBottom: 0 }}>
          <CardBody>
            <Table
              tableHead={[
                t("assignments:tableHeaders.assessment"),
                t("assignments:tableHeaders.purchased"),
                t("assignments:tableHeaders.used"),
                t("assignments:tableHeaders.available"),
                t("assignments:tableHeaders.pending"),
                t("assignments:tableHeaders.completed"),
                t("assignments:tableHeaders.assign"),
              ]}
              tableData={[
                [
                  t("assignments:assessmentNames.tool1_1"),
                  `${totalPurchased.tool1_1}`,
                  `${totalUsed.tool1_1}`,
                  `${totalPurchased.tool1_1 - totalUsed.tool1_1}${
                    subscriptionAvailable > 0
                      ? " + " + subscriptionAvailable
                      : ""
                  }`,
                  `${pending.tool1_1}`,
                  `${completed.tool1_1}`,
                  effectiveAvailableUnits.tool1_1 > 0 ? (
                    <Checkbox
                      key="key"
                      tabIndex={-1}
                      style={{ padding: 7 }}
                      onClick={() => handleToggle(1.1)}
                      checked={assignment["1.1"]}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checkedRed,
                        root: classes.checkRoot,
                      }}
                    />
                  ) : (
                    <Button
                      color="danger"
                      round
                      size="sm"
                      style={{ padding: 4, paddingLeft: 15, paddingRight: 15 }}
                      onClick={() => {
                        let currentCart = JSON.parse(
                          localStorage.getItem("cart")
                        );
                        currentCart["tool1_1"] += 1;
                        localStorage.setItem(
                          "cart",
                          JSON.stringify(currentCart)
                        );
                        cartContext.setCart(currentCart);
                      }}
                    >
                      {t("assignments:addToCart")}
                    </Button>
                  ),
                ],
                [
                  t("assignments:assessmentNames.tool1_2"),
                  `${totalPurchased.tool1_2}`,
                  `${totalUsed.tool1_2}`,
                  `${totalPurchased.tool1_2 - totalUsed.tool1_2}${
                    subscriptionAvailable > 0
                      ? " + " + subscriptionAvailable
                      : ""
                  }`,
                  `${pending.tool1_2}`,
                  `${completed.tool1_2}`,
                  effectiveAvailableUnits.tool1_2 > 0 ? (
                    <Checkbox
                      key="key"
                      tabIndex={-1}
                      style={{ padding: 7 }}
                      onClick={() => handleToggle(1.2)}
                      checked={assignment["1.2"]}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checkedRed,
                        root: classes.checkRoot,
                      }}
                    />
                  ) : (
                    <Button
                      color="danger"
                      round
                      size="sm"
                      style={{ padding: 4, paddingLeft: 15, paddingRight: 15 }}
                      onClick={() => {
                        let currentCart = JSON.parse(
                          localStorage.getItem("cart")
                        );
                        currentCart["tool1_2"] += 1;
                        localStorage.setItem(
                          "cart",
                          JSON.stringify(currentCart)
                        );
                        cartContext.setCart(currentCart);
                      }}
                    >
                      {t("assignments:addToCart")}
                    </Button>
                  ),
                ],
                [
                  t("assignments:assessmentNames.tool1_3"),
                  `${totalPurchased.tool1_3}`,
                  `${totalUsed.tool1_3}`,
                  `${totalPurchased.tool1_3 - totalUsed.tool1_3}${
                    subscriptionAvailable > 0
                      ? " + " + subscriptionAvailable
                      : ""
                  }`,
                  `${pending.tool1_3}`,
                  `${completed.tool1_3}`,
                  effectiveAvailableUnits.tool1_3 > 0 ? (
                    <Checkbox
                      key="key"
                      tabIndex={-1}
                      style={{ padding: 7 }}
                      onClick={() => handleToggle(1.3)}
                      checked={assignment["1.3"]}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checkedRed,
                        root: classes.checkRoot,
                      }}
                    />
                  ) : (
                    <Button
                      color="danger"
                      round
                      size="sm"
                      style={{ padding: 4, paddingLeft: 15, paddingRight: 15 }}
                      onClick={() => {
                        let currentCart = JSON.parse(
                          localStorage.getItem("cart")
                        );
                        currentCart["tool1_3"] += 1;
                        localStorage.setItem(
                          "cart",
                          JSON.stringify(currentCart)
                        );
                        cartContext.setCart(currentCart);
                      }}
                    >
                      {t("assignments:addToCart")}
                    </Button>
                  ),
                ],
              ]}
              customCellClasses={[
                classes.left,
                classes.center,
                classes.center,
                classes.center,
                classes.center,
                classes.center,
                classes.center,
              ]}
              customClassesForCells={[0, 1, 2, 3, 4, 5, 6]}
              customHeadCellClasses={[
                classes.left,
                classes.center,
                classes.center,
                classes.center,
                classes.center,
                classes.center,
                classes.center,
              ]}
              customHeadClassesForCells={[0, 1, 2, 3, 4, 5, 6]}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
